import {ScrollTrigger} from 'gsap/ScrollTrigger';

const init = ({callback, timeOut = 1500}) => {
	/* eslint-disable */
	async function allVideosHasBeenLoaded() {
		// Select all videos to a nodelist
		const allVideosElements = document.querySelectorAll('video');

		// If there's at least one node
		if (allVideosElements.length > 0) {
			// Transform to an array
			let allVideosElementsArr = Array.from(allVideosElements);

			// Wait until all videos will be loaded
			Promise.all(allVideosElementsArr.map(function (video) {
				return new Promise(function (resolve, reject) {
					video.addEventListener('loadeddata', function () {
						resolve();
					});
				});
			}))
				.then(function () {
					// All videos are loaded and we can resolve the "allVideosHasBeenLoaded" promise
					return Promise.resolve();
				});
		} else {
			return Promise.resolve();
		}
	}

	window.addEventListener('load', async () => {
		await allVideosHasBeenLoaded();
		// console.log('Load fired')
		setTimeout(() => {
			callback?.();
			ScrollTrigger.refresh();
		}, timeOut);
	});
}

export default {
	init,
};
